/**
 * hexTabModel — pure helpers for the Palette Modal V2 "Hex" tab (HexTab.jsx).
 *
 * Kept side-effect-free (no React/redux) so the redux-record shape and the
 * rehydrate-from-existing logic can be unit-tested directly. Builds on the
 * BrandPaletteWizard logic primitives (initialStops / makeStop / paletteHexes).
 */
import { initialStops, makeStop, paletteHexes } from "./BrandPaletteWizard/logic";

/**
 * Build the colorPalette-slice "color" record from the current stops + name.
 * Matches the shape the modal's Select path reads: a single selected palette
 * with `colors: [{ hex, id, index, selected, locked }]`. Color ids are derived
 * deterministically from the stable session paletteId (never Math.random — key
 * stability gate G-57).
 */
export const toPalette = (paletteId, name, stops) => ({
  index: 0,
  id: paletteId,
  paletteName: String(name || "Brand colors").trim() || "Brand colors",
  selected: true,
  colors: paletteHexes(stops).map((hex, i) => ({
    hex,
    id: `${paletteId}-c${i}`,
    index: i,
    selected: false,
    locked: false,
  })),
});

/**
 * Rebuild an editable stop list from an existing redux color palette (e.g. the
 * user switched tabs and came back). Falls back to the deck default palette when
 * there is nothing to rehydrate.
 */
export const stopsFromPalette = (palette) => {
  const colors = palette && Array.isArray(palette.colors) ? palette.colors : [];
  if (!colors.length) return initialStops();
  return colors.map((c) => makeStop(c.hex));
};
